export default {
  messages: {
    title: "A kosárba tett cikkre mennyiségi kedvezmény kapható!",
    text: {
      sku: "Fétis cikkszám",
      discountHead: "Kedvezmény adatok",
      discountQuantity: "Mennyiségi egység",
      discountPercent: "Kedvezmény",
      addedToCart: "Kosárba tett mennyiség: {quantity}",
      discountBreakdown: "Mennyiségi bontás",
      discountPricePerUnit: "Ár/{unit}",
      discountPriceTotal: "Teljes ár",
      totalDiscount: "Összesen"
    }
  },
  numberFormats: {
    currency: {
      style: "currency",
      currency: "HUF"
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  datetimeFormats: {
    date: {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    datetime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    },
    time: {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }
  }
}